import { render } from "./VDatepicker.vue?vue&type=template&id=618a278e"
import script from "./VDatepicker.vue?vue&type=script&lang=js"
export * from "./VDatepicker.vue?vue&type=script&lang=js"

import "./VDatepicker.vue?vue&type=style&index=0&id=618a278e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__